<template>
    <div class="overlay" v-if="show" :style="`opacity: ${opacity};`"></div>
</template>

<script>
export default {
    name: "Overlay",
    props: {
        show: Boolean,
        opacity: Number
    }
};
</script>